/**
 * CÓPIA de `apps/web/src/componentes/aurora-background.tsx` (a identidade da
 * tela de login). `web` e `site` são bundles separados de propósito — ver a
 * nota de duplicação no topo de `../estilos.css` e D20 em
 * `docs/DIVIDA_TECNICA.md`.
 *
 * Sempre `absolute inset-0`, `pointer-events-none`: quem monta a página
 * decide o `position: relative` do pai. Toda cor sai de token `--color-auth-*`
 * (`estilos.css`) — nada escrito na mão aqui.
 */
export function AuroraBackground(): JSX.Element {
  return (
    <div
      aria-hidden
      className="auth-aurora pointer-events-none absolute inset-0 overflow-hidden"
    >
      <div className="auth-aurora__blob auth-aurora__blob--a animate-auth-deriva-a" />
      <div className="auth-aurora__blob auth-aurora__blob--b animate-auth-deriva-b" />
      <div className="auth-aurora__blob auth-aurora__blob--c animate-auth-deriva-c" />
      <div className="auth-aurora__grade" />
      <div className="auth-aurora__grao" />
    </div>
  );
}
